import {getParam} from "./utils";
import $ from "jquery";

const commonUpload = (manualEvent) => {
    dataLayer.push({
        event: 'creatEvt',
        manualEvent
    })
}

export const init = () => {
    dataLayer.push({
        event: 'entrance',
        scid: getParam('scid'),
        cid: getParam('cid'),
    });
    $('.j-collect').on('click',({target}) => {
        let eventName = target.dataset.collect
        eventName && commonUpload(`点击-${eventName}`)
    })
}